import script from "./GodApeQuestWalletItemCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GodApeQuestWalletItemCard.vue?vue&type=script&setup=true&lang=js"

import "./GodApeQuestWalletItemCard.vue?vue&type=style&index=0&id=9bd87c9e&lang=scss"

const __exports__ = script;

export default __exports__